import { render, staticRenderFns } from "./SlotProviderPage.vue?vue&type=template&id=6dba5662&"
import script from "./SlotProviderPage.vue?vue&type=script&lang=js&"
export * from "./SlotProviderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports